export const dataModuleType = {
  type: 'string',
  minLength: 1,
};
